/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig } from './lais/httpHelpers';

class ConversationBuyerProfilesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  basePath(conversationId) {
    return resourcePath(this.url, conversationId, 'buyer_profile');
  }

  get(conversationId) {
    return axios.get(this.basePath(conversationId), requestConfig());
  }

  update(conversationId, payload = {}) {
    return axios.patch(this.basePath(conversationId), payload, requestConfig());
  }
}

export default new ConversationBuyerProfilesAPI();
